export default __webpack_public_path__ + "static/media/3dKey.d0681ad4.webp";